<template>
    <Cascader :value="areaIdList" :data="provinceList" :load-data="loadData" :disabled="disabled" @on-change="onChange" transfer :change-on-select="changeOnSelect"></Cascader>
</template>
<script>

export default {
    model: {
        prop: 'value',
        event: 'on-select-change'
    },
    props: {
        value: String,
        disabled: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: ""
        },
        changeOnSelect: {
            type: Boolean,
            default: false
        },
        unknownAddress: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        areaIdList: function () {
            if (!this.value) return [];

            let provinceId = this.value.substring(0, 2) + '0000';
            let cityId = this.value.substring(0, 4) + '00';
            return [provinceId, cityId, this.value]
        }
    },

    data() {
        return {
            provinceList: [],
        }
    },
    mounted() {
        this.loadProvinceList();
    },
    methods: {
        async loadProvinceList() {

            let params = {
                url: 'http://CORE-COMMON/messageService/dictService/queryEntries',
                body: {
                    type: 'province',
                    namespace: "region"
                }
            }

            let provinceList = await this.invoke(params);

            if (!this.unknownAddress) {
                provinceList = provinceList.filter(({ code }) => code != '010000');
            }

            this.provinceList = provinceList.map(({ code, text, type }) => {
                return { label: text, value: code, children: [], loading: false, type }
            })
        },

        async loadData(item, callback) {

            item.loading = true;

            let { type, value } = item;

            let typeList = ['province', 'city', 'area'];

            let params = {
                url: 'http://CORE-COMMON/messageService/dictService/queryEntries',
                body: {
                    type: typeList[typeList.indexOf(type) + 1],
                    namespace: "region",
                    superCode: value,
                }
            }

            let list = await this.invoke(params);

            item.children = list.map(({ code, text, type }) => {
                let ele = { label: text, value: code, type }
                if (type == 'city') {
                    ele.children = [];
                    // 表示能不能加载下一级
                    ele.loading = false;
                }
                return ele;
            })

            item.loading = false;
            callback();

        },
        //返回区域码就行了
        onChange(value) {
            if (this.changeOnSelect) {
                this.$emit('on-select-change', value[value.length - 1])
            } else {
                this.$emit('on-select-change', value[2])

            }
        }
    },
}
</script>
